module.exports = __webpack_public_path__ + "assets/img/style_default.41f6ddd4.jpg";